module.exports = __webpack_public_path__ + "static/gametime-logo-94fbd8c960d96dd4790bcd187a81dc2a.svg";